
import { Prop, Ref } from "vue-property-decorator";
import { scaleLinear } from "d3-scale";
import { line } from "d3-shape";
import { select } from "d3-selection";
import { axisBottom, axisLeft } from "d3-axis";
import ChartMixin from "../../helpers/mixins/chart";
import { extent } from "d3";
export default class TrendSummaryChart extends ChartMixin {
  @Ref("container") readonly container!: HTMLElement;
  @Prop({ type: Array, required: true }) readonly chartData!: {
    name: string;
    value: number;
  }[];
  draw() {
    const margin = { top: 40, right: 20, bottom: 140, left: 50 },
      width = this.container.clientWidth - margin.left - margin.right,
      height = 400 - margin.top - margin.bottom;
    const x = scaleLinear().range([0, width]);
    const y = scaleLinear().range([height, 0]);
    const minValueY = 20;
    const maxValueY = 80;
    select(this.container)
      .select("svg")
      .remove();
    const svg = select(this.container)
      .append("svg")
      .attr("width", "100%")
      .attr("height", height + margin.top + margin.bottom + 50)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    const data = this.chartData.map((d, i) => ({
      name: d.name,
      value: d.value,
      index: i
    }));
    // Scale the range of the data
    x.domain(
      // @ts-ignore
      extent(data, function(d) {
        // @ts-ignore
        return d.index;
      })
    );
    // @ts-ignore
    y.domain([minValueY, maxValueY]);
    svg.append("g").call(axisLeft(y));

    svg
      .append("g")
      .attr("class", "grid")
      .attr("transform", "translate(0," + height + ")")
      .call(
        axisBottom(x)
          .ticks(this.chartData.length)
          // .tickSize(-height)
          .tickFormat(d => {
            // @ts-ignore
            return this.chartData[d].name.replace("ﾓﾗﾄﾘｱﾑ", "モラトリアム").padEnd(8, "　");
          })
      )
      .selectAll("text")
      .attr("font-size", "12px")
      .attr("writing-mode", "tb-rl")
      .attr("text-anchor", "middle")
      .attr("y", 70);
    svg
      .append("g")
      .attr("class", "grid")
      .style("color", "grey")
      .style("opacity", 0.25)
      .call(
        axisLeft(y)
          .ticks(12)
          .tickSize(-width)
          // @ts-ignore
          .tickFormat("")
      );
    svg
      .append("path")
      .data([data])
      .attr("fill", "none")
      .attr("stroke", "#174A84")
      .attr("stroke-width", 1.5)
      .attr(
        "d",
        // @ts-ignore
        line()
          .x(function(d) {
            // @ts-ignore
            return x(d.index);
          })
          .y(function(d) {
            // @ts-ignore
            return y(d.value);
          })
      );
  }
  updated() {
    this.draw();
  }
  mounted() {
    this.draw();
  }
}
